/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import BorderColorIcon from '@mui/icons-material/BorderColor'
import CloseIcon from '@mui/icons-material/Close'
import 'react-multi-date-picker/styles/layouts/mobile.css'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  IconButton,
  InputLabel,
  List,
  styled,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress'
import { Dispatch } from '@reduxjs/toolkit'
import { CircularProgressBar } from '@tomik23/react-circular-progress-bar'
import { toFarsiDigits } from 'farsi-digits'
import { Formik } from 'formik'
import _ from 'lodash'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import InputIcon from 'react-multi-date-picker/components/input_icon'
import TimePicker from 'react-multi-date-picker/plugins/time_picker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Speedometer, { Arc, Background, Indicator, Progress } from 'react-speedometer/dist'
import sf from 'seconds-formater'
import * as Yup from 'yup'

import { IsCarItem } from '../../interfaces/IsCarItem'
import { IsItem } from '../../interfaces/IsItem'
import { FormField, SubmitButton, Form } from '../../shared/forms'
import FormSelect from '../../shared/forms/FormSelect'
import Input from '../../shared/Input'
import Select from '../../shared/Select'
import {
  createPeriodicService,
  getDevice,
  getDeviceList,
  getDeviceStatus,
  getError,
  getLoading,
  getMessage,
  getPeriodicServiceList,
  getStatusDevice,
  periodicDelete,
  periodicServiceList,
  resetPeriodicList,
  setError,
  setMessage,
  updatePeriodicService,
} from '../../store/devices'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },

  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

export interface DialogTitleProps {
  id: string
  children?: React.ReactNode
  onClose: () => void
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            left: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}
// لیست نوع سرویس
const partType: IsItem[] = [
  { id: '1', label: 'شمع', value: '2' },
  { id: '2', label: 'روغن ', value: '4' },
  { id: '3', label: 'تسمه تایم', value: '8' },
]
// لیست مفادیر سرویس
const kmType: IsCarItem[] = [
  { id: '1', label: '1000', value: '1', company: 'roghan' },
  { id: '2', label: '2000', value: '2', company: 'roghan' },
  { id: '3', label: '3000', value: '3', company: 'roghan' },
  { id: '4', label: '4000', value: '4', company: 'roghan' },
  { id: '5', label: '5000', value: '5', company: 'roghan' },
  { id: '6', label: '6000', value: '6', company: 'roghan' },
  { id: '7', label: '7000', value: '7', company: 'roghan' },
  { id: '8', label: '8000', value: '8', company: 'roghan' },
  { id: '9', label: '9000', value: '9', company: 'roghan' },
  { id: '10', label: '10000', value: '10', company: 'roghan' },
  { id: '11', label: '11000', value: '11', company: 'roghan' },
  { id: '12', label: '12000', value: '12', company: 'roghan' },
  { id: '13', label: '5000', value: '13', company: 'sham' },
  { id: '14', label: '10000', value: '14', company: 'sham' },
  { id: '15', label: '15000', value: '15', company: 'sham' },
  { id: '16', label: '20000', value: '16', company: 'sham' },
  { id: '17', label: '30000', value: '17', company: 'sham' },
  { id: '18', label: '35000', value: '18', company: 'sham' },
  { id: '19', label: '40000', value: '19', company: 'sham' },
  { id: '20', label: '45000', value: '20', company: 'sham' },
  { id: '21', label: '50000', value: '21', company: 'sham' },
  { id: '22', label: '55000', value: '22', company: 'sham' },
  { id: '23', label: '60000', value: '23', company: 'sham' },
  { id: '24', label: '65000', value: '24', company: 'sham' },
  { id: '25', label: '70000', value: '25', company: 'sham' },
  { id: '26', label: '75000', value: '26', company: 'sham' },
  { id: '27', label: '80000', value: '27', company: 'sham' },
  { id: '28', label: '85000', value: '28', company: 'sham' },
  { id: '29', label: '90000', value: '29', company: 'sham' },
  { id: '30', label: '95000', value: '30', company: 'sham' },
  { id: '31', label: '100000', value: '31', company: 'sham' },
  { id: '32', label: '5000', value: '32', company: 'tasme' },
  { id: '33', label: '10000', value: '33', company: 'tasme' },
  { id: '34', label: '15000', value: '34', company: 'tasme' },
  { id: '35', label: '20000', value: '35', company: 'tasme' },
  { id: '36', label: '30000', value: '36', company: 'tasme' },
  { id: '37', label: '35000', value: '37', company: 'tasme' },
  { id: '38', label: '40000', value: '38', company: 'tasme' },
  { id: '39', label: '45000', value: '39', company: 'tasme' },
  { id: '40', label: '50000', value: '40', company: 'tasme' },
  { id: '41', label: '55000', value: '41', company: 'tasme' },
  { id: '42', label: '60000', value: '42', company: 'tasme' },
  { id: '43', label: '65000', value: '43', company: 'tasme' },
  { id: '44', label: '70000', value: '44', company: 'tasme' },
  { id: '45', label: '75000', value: '45', company: 'tasme' },
  { id: '46', label: '80000', value: '46', company: 'tasme' },
  { id: '47', label: '85000', value: '47', company: 'tasme' },
  { id: '48', label: '90000', value: '48', company: 'tasme' },
  { id: '49', label: '95000', value: '49', company: 'tasme' },
  { id: '50', label: '100000', value: '50', company: 'tasme' },
]
interface FormValues {
  part: string
  replacementDate: string
  replacementKilometer: string
  reminderKilometer: string
  note: string
}

const initialValues: FormValues = {
  part: partType[0].value,
  replacementDate: '',
  replacementKilometer: '',
  reminderKilometer: kmType[12].value,
  note: '',
}

const validationSchema = Yup.object().shape({
  replacementDate: Yup.string().required('ورود تاریخ الزامی است').label('تاریخ'),
  replacementKilometer: Yup.string()
    .required('ورود کیلومتر تعویض الزامی است')
    .label('کیلومتر تعویض')
    .matches(/^[0-9]*$/, 'لطفا کیلومتر تعویض را به درستی وارد نمایید'),
  reminderKilometer: Yup.string()
    .required('انتخاب یادآوری کیلومتر اجباری است')
    .label('یاداوری کیلومتر'),
  note: Yup.string().label('یادداشا'),
})
interface FormValues1 {
  part1: string
  replacementDate1: string
  replacementKilometer1: string
  reminderKilometer1: string
  note1: string
}

const validationSchema1 = Yup.object().shape({
  replacementDate1: Yup.string().required('ورود تاریخ الزامی است').label('تاریخ'),
  replacementKilometer1: Yup.string()
    .required('ورود کیلومتر تعویض الزامی است')
    .label('کیلومتر تعویض')
    .matches(/^[0-9]*$/, 'لطفا کیلومتر تعویض را به درستی وارد نمایید'),
  reminderKilometer1: Yup.string()
    .required('انتخاب یادآوری کیلومتر اجباری است')
    .label('یاداوری کیلومتر'),
  note1: Yup.string().label('یادداشا'),
})
const PeriodicServiceScreen = () => {
  const { t } = useTranslation()
  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD')
  }
  const shamsi1 = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD',
    })
    date.convert(persian, persian_fa)
    date.subtract(3, 'hour')
    date.subtract(30, 'minute')
    return date.format('YYYY/MM/DD')
  }
  const [periodic, setPeriodic] = React.useState<any>()

  const initialValues1: FormValues1 = {
    part1: periodic?.part === 'شمع' ? '2' : periodic?.part === 'روغن' ? '4' : '8' ?? '',
    replacementDate1: periodic?.replacementDate ?? '',
    replacementKilometer1: periodic?.replacementKilometer ?? '',
    reminderKilometer1: periodic?.reminderKilometer ?? '',
    note1: periodic?.note ?? '',
  }
  const loading = useSelector(getLoading)
  const error = useSelector(getError)
  const message = useSelector(getMessage)
  const list = useSelector(getStatusDevice)

  const { enqueueSnackbar } = useSnackbar()
  const { id } = useParams()
  const periodicList = useSelector(getPeriodicServiceList)
  const dispatch = useDispatch<Dispatch<any>>()
  useEffect(() => {
    if (id !== undefined) dispatch(periodicServiceList({ deviceId: id }))
  }, [])
  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)
  const handleClose = () => {
    setOpen(false)
  }
  const handleToggle = () => {
    setOpen(!open)
  }
  const [open2, setOpen2] = React.useState(false)
  const [open3, setOpen3] = React.useState(false)
  const handleClose2 = () => {
    setOpen2(false)
  }
  const handleClose3 = () => {
    setOpen3(false)
  }
  function handleChange(dateFrom: any) {
    const date = new DateObject({
      calendar: persian,
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      date: `${dateFrom.year}-${dateFrom.month}-${dateFrom.day} ${dateFrom.hour}:${dateFrom.minute}`,
    })
    const a = date.format('YYYY-MM-DD HH:mm')
    // setDate1(a)

    date.subtract(3, 'hour')
    date.subtract(30, 'minute')
    // date.add(1, "days");

    date.convert(gregorian, gregorian_en)

    // dispatch(setDateFrom(date.format('YYYY-MM-DD HH:mm')))
  }
  const convertKilometer = (meter: number) => {
    if (meter < 1000) {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return _.split(meter.toString(), '.', 1) + 'M'
    } else {
      const convert = Math.round(meter / 100) / 10
      const convertation: any = _.split(convert.toString(), '.', 2)
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      const num1 = convertation[1] !== undefined ? convertation[1] * 100 + 'M' : ''

      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return convertation[0] + 'Km' + num1
    }
  }
  useEffect(() => {
    return () => {
      dispatch(resetPeriodicList)
    }
  }, [])
  useEffect(() => {
    if (id !== undefined) dispatch(getDeviceStatus(id))
  }, [])
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
  }, [message])
  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  const handleSubmit = (values: any) => {
    dispatch(
      createPeriodicService({
        deviceId: id,
        part: values.part,
        replacementDate: values.replacementDate,
        replacementKilometer: values.replacementKilometer,
        reminderKilometer: values.reminderKilometer,
        note: values.note,
      }),
    )
    setOpen2(false)
  }
  const handleSubmit1 = (values: any) => {
    dispatch(
      updatePeriodicService({
        id: periodic?.id,
        part: values.part1,
        replacementDate: values.replacementDate1,
        replacementKilometer: values.replacementKilometer1,
        reminderKilometer: values.reminderKilometer1,
        note: values.note1,
      }),
    )
    setOpen3(false)
  }

  const getCarModels = (companyId: string) => {
    switch (companyId) {
      case '2':
        return kmType.filter((p) => p.company === 'sham')
      case '4':
        return kmType.filter((p) => p.company === 'roghan')
      case '8':
        return kmType.filter((p) => p.company === 'tasme')

      default:
        return kmType
    }
  }

  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          direction: 'ltr',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2 }}>
          <ArrowBackRoundedIcon
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: 'red',
              borderRadius: '50%',
              color: '#fff',

              cursor: 'pointer',
            }}
          />
          <img alt='Logo' src='/images/TinyLogo.png' />
        </Box>
        <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <CircularProgress color='inherit' />
        </Backdrop>
        <Box sx={{ mb: 1, ml: 1 }}>
          <Fab
            aria-label='add'
            color='primary'
            onClick={() => {
              setOpen2(true)
            }}
            size='medium'
            sx={{ margin: '8px 0', width: '100%' }}
            variant='extended'
          >
            {t('screens.PeriodicServiceScreen.create_a_new_periodic_service')}
          </Fab>
        </Box>
        {periodicList?.length !== 0 && (
          <Box>
            <Card
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                flexWrap: 'wrap',
                p: 1,
                background: 'linear-gradient(rgb(35 75 75), #aaaaaa)',
                boxShadow: ' 4px 3px 9px',
              }}
            >
              {periodicList?.length !== 0 &&
                periodicList?.map((p: any) => (
                  <Box display='flex' flexDirection='column' key={p.id} sx={{ m: 0.35 }}>
                    <CircularProgressBar
                      colorCircle='#fff'
                      fontColor='#fff'
                      fontSize='1.2rem'
                      fontWeight={600}
                      linearGradient={['green', 'yellow']}
                      percent={100}
                      rotation={144}
                      size={110}
                      stroke={6}
                      strokeBottom={10}
                      strokeDasharray='1, 3'
                      styles={{
                        borderRadius: '50%',
                        boxShadow: 'inset 0 0 25px 10px black',
                        position: 'relative',
                      }}
                      textPosition='0em'
                    >
                      <div
                        style={{
                          bottom: '30px',
                          fontSize: '1rem',
                          margin: 'auto',
                          position: 'absolute',
                          textAlign: 'center',
                          color: '#fff',
                          width: '100%',
                        }}
                      >
                        {p.part}
                      </div>
                    </CircularProgressBar>
                    <Box
                      alignItems='center'
                      display='flex'
                      flexDirection='column'
                      justifyContent='center'
                    >
                      <Typography>
                        {t('screens.PeriodicServiceScreen.replacement_date_show')}
                      </Typography>
                      <Typography>{shamsi(p?.replacementDate)}</Typography>
                    </Box>

                    <ToggleButtonGroup
                      aria-label='text alignment'
                      exclusive
                      sx={{ alignSelf: 'center', mt: 1 }}
                      // onChange={handleAlignment}
                      // value={alignment}
                    >
                      <ToggleButton
                        aria-label='left aligned'
                        onClick={() => {
                          setPeriodic(p)
                          setOpen3(true)
                        }}
                        sx={{ background: 'transparent', color: 'red', p: '10px' }}
                        value='left'
                      >
                        <BorderColorIcon />
                      </ToggleButton>
                      <ToggleButton
                        aria-label='centered'
                        onClick={() => {
                          dispatch(periodicDelete(p.id))
                        }}
                        sx={{ background: 'transparent', color: 'red', p: '10px' }}
                        value='center'
                      >
                        <DeleteForeverIcon />
                      </ToggleButton>
                    </ToggleButtonGroup>
                    {/* <Box display='flex' justifyContent='center' sx={{ mt: 1 }}>
                    <IconButton>
                      <Fab aria-label='add' color='primary' size='small' variant='extended'>
                        <BorderColorIcon sx={{ mr: 1 }} />
                        ویرایش
                      </Fab>
                    </IconButton>
                  </Box> */}
                  </Box>
                ))}
            </Card>
          </Box>
        )}
        <div>
          <BootstrapDialog
            aria-labelledby='customized-dialog-title'
            open={open2}
            sx={{
              direction: 'rtl',

              '& .MuiDialog-paper': {
                width: '400px',
                zIndex: 100000000000000000,
              },
            }}
          >
            <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose2}>
              {t('screens.PeriodicServiceScreen.new_periodic_service')}
            </BootstrapDialogTitle>
            <Divider />
            <Box>
              <Card
                sx={{
                  color: 'grey.700',
                  boxShadow: 0,
                  borderRadius: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                  mr: 1,
                  alignItems: 'center',
                }}
              >
                <Box display='flex'>
                  <Typography sx={{ fontSize: '0.85rem' }}>
                    {t('screens.PeriodicServiceScreen.KM_from_ECU')}
                  </Typography>
                </Box>
                <Box display='flex' sx={{ ml: 1 }}>
                  <Typography sx={{ fontSize: '0.85rem' }}>
                    {convertKilometer(_.toNumber(list?.lastODOFromOBD))}
                  </Typography>
                </Box>
              </Card>
              <Card
                sx={{
                  color: 'grey.700',
                  boxShadow: 0,
                  borderRadius: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                  mr: 1,
                  alignItems: 'center',
                }}
              >
                <Box display='flex'>
                  <Typography sx={{ fontSize: '0.85rem' }}>
                    {t('screens.PeriodicServiceScreen.KM_from_date_install_device')}
                  </Typography>
                </Box>
                <Box display='flex' sx={{ ml: 1 }}>
                  <Typography sx={{ fontSize: '0.85rem' }}>
                    {convertKilometer(_.toNumber(list?.lastODO))}
                  </Typography>
                </Box>
              </Card>
              <Card
                sx={{
                  color: 'grey.700',
                  borderRadius: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                  boxShadow: 0,
                  alignItems: 'center',
                  mr: 1,
                }}
              >
                <Box display='flex'>
                  <Typography sx={{ fontSize: '0.85rem' }}>
                    {t(
                      'screens.PeriodicServiceScreen.Power_on_time_from_the_device_installation date',
                    )}
                  </Typography>
                </Box>
                <Box display='flex' sx={{ ml: 1 }}>
                  <Typography sx={{ fontSize: '0.85rem' }}>
                    {list?.lastRuntime !== undefined &&
                      sf.convert(_.toNumber(list?.lastRuntime)).format('HH:MM:SS')}
                  </Typography>
                </Box>
              </Card>
            </Box>
            <Divider />
            <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,

                  /* and other goodies */
                }) => (
                  <>
                    <form onSubmit={handleSubmit}>
                      <InputLabel id='demo-simple-select-label'>
                        {t('screens.PeriodicServiceScreen.type_service')}
                      </InputLabel>
                      <Select
                        fullWidth
                        items={partType}
                        name='part'
                        onBlur={handleBlur}
                        onChange={(e: any) => {
                          handleChange(e)
                          setFieldValue('reminderKilometer', getCarModels(e.target.value)[0].value)
                        }}
                        sx={{ minHeight: '2.5em' }}
                        value={values.part}
                      />
                      <div style={{ color: 'red', fontSize: '10px' }}>{errors.part}</div>
                      <InputLabel id='demo-simple-select-label'>
                        {t('screens.PeriodicServiceScreen.replacement_date')}
                      </InputLabel>
                      <Box
                        alignItems='center'
                        display='flex'
                        flexDirection='column'
                        justifyContent='center'
                        sx={{
                          m: 0,
                          borderRadius: 2,
                          '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                          '& .rmdp-action-button': { fontFamily: 'Vazir' },
                          '& .rmdp-container ': { width: '100%' },
                          '& .rmdp-input': {
                            fontFamily: 'Vazir',
                            minHeight: '3em',
                            width: '100%',
                            border: '1px solid black',
                            paddingRight: '11px',
                          },
                        }}
                      >
                        <div
                          style={{
                            direction: 'rtl',
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '3px',
                            width: '100%',
                          }}
                        >
                          <DatePicker
                            calendar={persian}
                            calendarPosition='top-right'
                            className='rmdp-mobile'
                            format='YYYY/MM/DD'
                            locale={persian_fa}
                            maxDate={new DateObject({ calendar: persian })}
                            onChange={(e: any) => {
                              const date = new DateObject({
                                calendar: persian,
                                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                                date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                              })

                              date.subtract(3, 'hour')
                              date.subtract(30, 'minute')

                              date.convert(gregorian, gregorian_en)
                              setFieldValue('replacementDate', date.format('YYYY-MM-DD HH:mm'))
                            }}
                            render={<InputIcon />}
                            style={{ width: '100%', border: '2px solid #black' }}
                            zIndex={10000000}
                          />
                        </div>
                      </Box>
                      <div style={{ color: 'red', fontSize: '12px' }}>{errors.replacementDate}</div>
                      <InputLabel id='demo-simple-select-label'>
                        {t('screens.PeriodicServiceScreen.replacement_km')}
                      </InputLabel>
                      <Input
                        autoComplete='off'
                        fullWidth
                        name='replacementKilometer'
                        onBlur={handleBlur}
                        onChange={(e: any) => handleChange(e)}
                        sx={{ height: '2.5em' }}
                        value={values.replacementKilometer}
                      />
                      <div style={{ color: 'red', fontSize: '12px' }}>
                        {errors.replacementKilometer}
                      </div>
                      <InputLabel id='demo-simple-select-label'>
                        {t('screens.PeriodicServiceScreen.reminder_km')}
                      </InputLabel>
                      <Select
                        fullWidth
                        items={getCarModels(values.part)}
                        name='reminderKilometer'
                        onBlur={handleBlur}
                        onChange={(e: any) => handleChange(e)}
                        sx={{ minHeight: '2.5em' }}
                        value={values.reminderKilometer}
                      />
                      <div style={{ color: 'red', fontSize: '12px' }}>
                        {errors.reminderKilometer}
                      </div>
                      <InputLabel id='demo-simple-select-label'>
                        {t('screens.PeriodicServiceScreen.note')}
                      </InputLabel>
                      <Input
                        autoComplete='off'
                        fullWidth
                        name='note'
                        onBlur={handleBlur}
                        onChange={(e: any) => handleChange(e)}
                        sx={{ height: '2.5em' }}
                        value={values.note}
                      />
                      <div style={{ color: 'red' }}>{errors.note}</div>
                      <Button
                        fullWidth
                        onClick={(e) => {
                          handleSubmit()
                        }}
                        variant='contained'
                      >
                        {t('screens.PeriodicServiceScreen.save')}
                      </Button>
                    </form>
                  </>
                )}
              </Formik>
            </DialogContent>
          </BootstrapDialog>
        </div>
        <div>
          <BootstrapDialog
            aria-labelledby='customized-dialog-title'
            open={open3}
            sx={{
              direction: 'rtl',
              '& .MuiDialog-paper': { width: '400px', zIndex: 100000000000000000 },
            }}
          >
            <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose3}>
              {t('screens.PeriodicServiceScreen.edit_periodic_service')}
            </BootstrapDialogTitle>
            <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
              <Formik
                enableReinitialize={true}
                initialValues={initialValues1}
                onSubmit={handleSubmit1}
                validationSchema={validationSchema1}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,

                  /* and other goodies */
                }) => (
                  <>
                    <form onSubmit={handleSubmit1}>
                      <InputLabel id='demo-simple-select-label'>
                        {' '}
                        {t('screens.PeriodicServiceScreen.type_service')}
                      </InputLabel>
                      <Select
                        fullWidth
                        items={partType}
                        name='part1'
                        onBlur={handleBlur}
                        onChange={(e: any) => {
                          handleChange(e)
                          setFieldValue('reminderKilometer1', getCarModels(e.target.value)[0].value)
                        }}
                        value={values.part1}
                      />
                      <div style={{ color: 'red', fontSize: '10px' }}>{errors.part1}</div>
                      <InputLabel id='demo-simple-select-label'>
                        {t('screens.PeriodicServiceScreen.replacement_date')}
                      </InputLabel>
                      <Box
                        alignItems='center'
                        display='flex'
                        flexDirection='column'
                        justifyContent='center'
                        sx={{
                          m: 0,
                          borderRadius: 2,
                          '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                          '& .rmdp-action-button': { fontFamily: 'Vazir' },
                          '& .rmdp-container ': { width: '100%' },
                          '& .rmdp-input': {
                            fontFamily: 'Vazir',
                            minHeight: '49px',
                            width: '100%',
                            border: '1px solid black',
                            paddingRight: '11px',
                          },
                        }}
                      >
                        <div
                          style={{
                            direction: 'rtl',
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '3px',
                            width: '100%',
                          }}
                        >
                          <DatePicker
                            calendar={persian}
                            calendarPosition='top-right'
                            className='rmdp-mobile'
                            format='YYYY/MM/DD'
                            locale={persian_fa}
                            maxDate={new DateObject({ calendar: persian })}
                            onChange={(e: any) => {
                              const date = new DateObject({
                                calendar: persian,
                                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                                date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                              })

                              date.subtract(3, 'hour')
                              date.subtract(30, 'minute')

                              date.convert(gregorian, gregorian_en)
                              setFieldValue('replacementDate1', date.format('YYYY-MM-DD HH:mm'))
                            }}
                            render={<InputIcon />}
                            style={{ width: '100%', border: '2px solid #black' }}
                            value={shamsi(periodic?.replacementDate)}
                            zIndex={10000000}
                          />
                        </div>
                      </Box>
                      <div style={{ color: 'red', fontSize: '12px' }}>
                        {errors.replacementDate1}
                      </div>
                      <InputLabel id='demo-simple-select-label'>
                        {' '}
                        {t('screens.PeriodicServiceScreen.replacement_km')}
                      </InputLabel>
                      <Input
                        autoComplete='off'
                        fullWidth
                        name='replacementKilometer1'
                        onBlur={handleBlur}
                        onChange={(e: any) => handleChange(e)}
                        value={values.replacementKilometer1}
                      />
                      <div style={{ color: 'red', fontSize: '12px' }}>
                        {errors.replacementKilometer1}
                      </div>
                      <InputLabel id='demo-simple-select-label'>
                        {t('screens.PeriodicServiceScreen.reminder_km')}
                      </InputLabel>
                      <Select
                        fullWidth
                        items={getCarModels(values.part1)}
                        name='reminderKilometer1'
                        onBlur={handleBlur}
                        onChange={(e: any) => handleChange(e)}
                        value={values.reminderKilometer1}
                      />
                      <div style={{ color: 'red', fontSize: '12px' }}>
                        {errors.reminderKilometer1}
                      </div>
                      <InputLabel id='demo-simple-select-label'>
                        {t('screens.PeriodicServiceScreen.note')}
                      </InputLabel>
                      <Input
                        autoComplete='off'
                        fullWidth
                        name='note1'
                        onBlur={handleBlur}
                        onChange={(e: any) => handleChange(e)}
                        value={values.note1}
                      />
                      <div style={{ color: 'red' }}>{errors.note1}</div>
                      <Button
                        fullWidth
                        onClick={(e) => {
                          handleSubmit1(values)
                        }}
                        variant='contained'
                      >
                        {t('screens.PeriodicServiceScreen.edit')}
                      </Button>
                    </form>
                  </>
                )}
              </Formik>
            </DialogContent>
          </BootstrapDialog>
        </div>
      </Box>
    </Container>
  )
}

export default PeriodicServiceScreen
